<div class="page-header">
    <div class="page-header-image">
        <!-- <img src="../assets/NewAbideInChrist.png"> -->
        <picture>
            <source media="(min-width: 900px)" srcset="../assets/AbideInChristBannerLong.png">
            <source media="(min-width: 768px)" srcset="../assets/bannerAbideinChrist.png">
            <!-- <img src="../assets/NewAbideInChrist.png"> -->
        </picture>
    </div>

    <div class="page-border">


     <h1 class="page-header-title"><a target="_blank" href="https://www.cvcfministry.org/">{{titleOne}}</a></h1>
        <h3 class="page-header-subtitle">{{titleTwo}}</h3>
        <div class="page-header-text">
            <i><strong> </strong>"{{themeVerse}}"</i>
            <!-- <i>"{{themeVerse}}"</i> -->
            <br>
            <i><strong> </strong>{{themeVerseReference}}.</i>
            <br>
            <i><strong>{{themeverselocation}}</strong></i>
            <!-- <i>{{themeVerseReference}}</i> -->
        </div>

    </div>
</div>



<div class="page-border">
    <router-outlet></router-outlet>
</div>